import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {TeamAPI, CreateTeamAPI, AssignTeamCallerAPI, RemoveCallerFromTeamAPI} from "../../API/Sales/TeamAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import InvitationModal from "./InvitationModal";
import Loader from "../Loader";
import Paginate from "../../utils/Pagination";
//import DeleteConfirmPopup from "../../utils/DeleteConfirmPopup";
//import { ToastContainer } from "react-toastify";
import "./../../Public/css/leads_list.css";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
import ReactSelect from 'react-select';
import { Offcanvas } from 'react-bootstrap';
import PopupDelete from "./../PopupDelete";


const Teams = () =>{

    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [email, setEmail] = useState("");
    const [showdeletepopup, setShowDeletePopup] = useState(false);
    const [headertext, setHeaderText] = useState("Delete this caller?");
    const [deletepopupcontent, setDeletePopupContent] = useState("Are you sure to delete this caller from team?");
    const [deleteteamid, setDeleteTeamID] = useState(null);
    const [isteamdelete, setIsTeamDelete] = useState(false);
    const [isteamadd, setIsTeamAdd] = useState(false);
    const [showinvitespinner, setShowInviteSpinner] = useState(false);
    const [showdeletespinner, setShowDeleteSpinner] = useState(false);


    const [createteampopup, setCreateTeamPopup] = useState(false);
    const [addcallerteampopup, setAddCallerTeamPopup] = useState(false);

    const [teamleaderlist, setTeamLeaderList] = useState([]);
    const [teamtype, setTeamType] = useState("");
    const [teamleader, setTeamLeader] = useState("");
    const [teamtypevalue, setTeamTypeValue] = useState("");
    const [teamleadervalue, setTeamLeaderValue] = useState("");
    const [teamname, setTeamName] = useState("");
    const [iscallerassignteam, setIsCallerAssignTeam] = useState(false);
    const [iscreateteam, setIsCreateTeam] = useState(false);

    const [teamslist, setTeamslist] = useState([]);
    const [callerslist, setCallerslist] = useState([]);

    const [selectedteam, setSelectedTeam] = useState("");
    const [selectedteamvalue, setSelectedTeamValue] = useState("");
    const [selectedcallers, setSelectedCallers] = useState([]);
    const [selectedcallersvalue, setSelectedCallersValue] = useState([]);
    const [isreloaddata, setIsReloadData] = useState(false);


    const [totalrecords, setTotalRecords] = useState(0);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [delheading, setDelHeading] = useState("");
    const [delmessage, setDelMessage] = useState("");
    const [delteamid, setDelTeamId] = useState("");
    const [delcallerid, setDelCallerId] = useState("");

    const perpagedata = 20;

    const teamtypelist = [    
                                    {
                                        value: "ODL",
                                        label: "ODL"
                                    }, 
                                    {
                                        value: "Executive",
                                        label: "Executive"
                                    }
                                    
                                ]


    useEffect(() => {

        TeamAPI(setTeams, setTeamLeaderList, setCallerslist, setTeamslist, setLoading, currentPage, perpagedata, setPageCount, setIsReloadData);

        //console.log('>>>>'+usersList);

    }, [currentPage, isreloaddata]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleCreateTeamPopup = () =>{

        setCreateTeamPopup(!createteampopup);
    }

    const handleCreateTeamPopupClose = () =>{
        setCreateTeamPopup(false);
    }    

    const handleChangeName = (e) =>{

        setTeamName(e.target.value);
    }

    const handleChangeTeamType = (selteamtype) =>{

        setTeamType(selteamtype);
        setTeamTypeValue(selteamtype ? selteamtype.value : "");
    }

    const handleChangeTeamLeader = (selteamleader) =>{

        setTeamLeader(selteamleader);
        setTeamLeaderValue(selteamleader ? selteamleader.value : "");
    }

    const handleSubmitCreateTeam = () =>{
        
        console.log('TeamName===' + teamname);
        console.log('Team Type===' + teamtypevalue);
        console.log('Team Leader===' + teamleadervalue);

        const params = {
                        teamname: teamname,
                        teamtype: teamtypevalue,
                        teamleader: teamleadervalue
                    };

        console.log(params);

        CreateTeamAPI(params, setCreateTeamPopup, setIsReloadData);
    }

    const handleAddCallerTeamPopup = () =>{

        setAddCallerTeamPopup(!addcallerteampopup);
    }

    const handleAddCallerTeamPopupClose = () =>{
        setAddCallerTeamPopup(false);
    }

    const handleChangeTeamData = (selteam) =>{

        //setTeamLeader(selteamleader);
        //setTeamLeaderValue(selteamleader ? selteamleader.value : "");
        setSelectedTeam(selteam);
        setSelectedTeamValue(selteam ? selteam.value : "");
    }

    const handleChangeCallersData = (selcallers) =>{

        setSelectedCallers(selcallers);

        if(selcallers)
        {
            let callersvalue = selcallers.map(callerdatalist => callerdatalist.value);

            setSelectedCallersValue(callersvalue);

        }
    }

    const handleSubmitAssignCallerTeam = () =>{

        console.log('Team===' + selectedteamvalue);
        console.log('Callers===' + selectedcallersvalue);

        const params = {
                        team_id: selectedteamvalue,
                        caller_ids: selectedcallersvalue
                    }

        console.log(params);

        AssignTeamCallerAPI(params, setAddCallerTeamPopup, setIsReloadData);
    }

    const handleRemoveCallerFromTeam = (teamid, teamcallerid) =>{

        setDelHeading("Delete this user?");

		setDelMessage("Are you sure you want to delete this user?");

		setShowDeleteModal(true);

        console.log('>>>>' + teamid + '>>>>' + teamcallerid);

        setDelTeamId(teamid);

        setDelCallerId(teamcallerid);

    }

    const hideCallerDeletePopup = () =>{

        setDelHeading("");

		setDelMessage("");

		setShowDeleteModal(false);

		setDelTeamId("");

        setDelCallerId("");
    }

    const handleRemoveCaller = (event) =>{

        event.preventDefault();

        const params = { team_id: delteamid, caller_id: delcallerid } 

        RemoveCallerFromTeamAPI(params, setIsReloadData, setShowDeleteModal);

    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-sm-12">
                                <h4 className="page-title">Teams</h4>
                            </div>
                            <div className="col-lg-6 col-sm-12 d-flex justify-content-end p-0">
                                <button type="button" className="btn btn-primary me-2" onClick={handleCreateTeamPopup}>
                                    <i className="ti ti-plus me-2"></i>Create Team
                                </button>
                            
                                <button type="button" className="btn btn-primary" onClick={handleAddCallerTeamPopup}>
                                    <i className="ti ti-plus me-2"></i>Add Caller Team
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                {/*<div className="mb-2">
                                    <strong>Total Records:</strong> {totalrecords}
                                </div>*/}

                                <div className="table-responsive table-wrapper">
                                    {loading ?
                                        <ContentLoader />
                                    :
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>                                                
                                                <th style={{ width: "20%" }}>Caller</th>
                                                <th style={{ width: "20%" }}>Team</th>
                                                <th style={{ width: "15%" }}>Team Type</th>
                                                <th style={{ width: "15%" }}>Team Leader</th>
                                                <th style={{ width: "30%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {teams && teams.length > 0  ? 
                                                teams.map(team => 
                                                    (
                                            
                                                        <tr key={team.caller_id}>
                                                            <td>
                                                                <div class="avatar avatar-sm border flex-shrink-0 me-2">
                                                                    <span class="initials">{(team.caller_name ? team.caller_name : "-").slice(0,2)}</span>
                                                                </div>
                                                                <Link to={`/sales/team/${team.id}/callers`} class="">
                                                                {team.caller_name ? team.caller_name : "-"}
                                                                </Link>
                                                                
                                                            </td>
                                                            <td>{team.team_name}</td>
                                                            <td>{team.team_type}</td>
                                                            <td>{team.team_leader_name}</td>
                                                            
                                                            <td>  
                                                                <button type="button" class="btn btn-danger btn-sm" onClick={()=> handleRemoveCallerFromTeam(team.team_id, team.caller_id)}>
                                                                    <i className="ti ti-trash"></i> Remove
                                                                </button>	
                                                                                                    
                                                            </td>
                                                        </tr>
                                                    )
                                                )
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="4">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                    }
                                </div>
                                
                            </div>
                            

                        </div>
                    </div>
                    
                    {pagecount > 1 &&
                    <div className="row pagination-section">
                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    }

                </div>
            </div>
            
            {/*<InvitationModal toggleShow={showPopup} btnClose={handlePopupClose} btnTeamInvite={handleTeamInvite} inputEmail={handleInputEmail} txtemail={email} btninvitespin={showinvitespinner} />

            <DeleteConfirmPopup toggleDeleteShow={showdeletepopup} btnCancel={handleButtonCancel} btnDelete={handleButtonDelete} txtModalHeader={headertext} txtModalContent={deletepopupcontent} btndeletespin={showdeletespinner} />*/}

            <Offcanvas show={createteampopup} onHide={handleCreateTeamPopupClose} placement="end" className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title id="contained-modal-title-vcenter">Create Team</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    
                    <div class="row crm-filter-row-bottom align-items-end">
                        <div className="col-md-12 mb-1">
                            <label class="crm-filter-label">Team Name</label>
                            <input className="form-control" type="text" name="teamname" onChange={handleChangeName} placeholder="Enter team name" value={teamname} />
                        </div>
                        <div className="col-md-12 mb-1">
                            <label class="crm-filter-label">Team Type</label>
                            <ReactSelect className="" value={teamtype} onChange={handleChangeTeamType} options={teamtypelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team Type"></ReactSelect>
                        </div>
                        <div className="col-md-12 mb-1">
                            <label class="crm-filter-label">Team Leader</label>
                            <ReactSelect className="" value={teamleader} onChange={handleChangeTeamLeader} options={teamleaderlist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select team leader"></ReactSelect>
                        </div>

                    </div>
                    <div class="crm-filter-actions">
                        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleCreateTeamPopupClose}>Close</button>

                        <button type="button" className="btn btn-primary me-2" onClick={handleSubmitCreateTeam}>
                                <i className="ti ti-search me-2"></i>Apply Filter
                        </button>

                    </div>
                                
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas show={addcallerteampopup} onHide={handleAddCallerTeamPopupClose} placement="end" className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title id="contained-modal-title-vcenter">Add Callers To Team</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    
                    <div class="row crm-filter-row-bottom align-items-end">                        
                        <div className="col-md-12 mb-1">
                            <label class="crm-filter-label">Team </label>
                            <ReactSelect className="" value={selectedteam} onChange={handleChangeTeamData} options={teamslist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team"></ReactSelect>
                        </div>
                        <div className="col-md-12 mb-1">
                            <label class="crm-filter-label">Callers</label>
                            <ReactSelect className="" value={selectedcallers} onChange={handleChangeCallersData} options={callerslist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select callers" isMulti></ReactSelect>
                        </div>

                    </div>
                    <div class="crm-filter-actions">
                        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleAddCallerTeamPopupClose}>Close</button>

                        <button type="button" className="btn btn-primary me-2" onClick={handleSubmitAssignCallerTeam}>
                                <i className="ti ti-search me-2"></i>Assign Callers
                        </button>

                    </div>
                                
                </Offcanvas.Body>
            </Offcanvas>

            <PopupDelete message={delmessage} title={delheading} modalstatus={showDeleteModal} btnClickDelete={handleRemoveCaller} btnClickClose={hideCallerDeletePopup} />
        </div>
    </Layout>
    )
}

export default Teams;